import { memo, useEffect, useState } from 'react';
import { LegendData } from '../Map.types';
import FloatingWindow from './FloatingWindow';
import LegendContent from './LegendContent';
import { FloatingWindowDimensions } from '../../../components/sitebase/Base.types';
import { getDefaultDimensions } from '../../../utils/windowDimensions';
import { SuperEditorContext } from '../../../components/common/PermissionContext';
import FeatureFeedback from './FeatureFeedback';
import { FeedbackFeature } from '../services/FeatureFeedbackService';

export default memo(function Legend(props: {
    legend: LegendData | null,
    dimensions?: FloatingWindowDimensions,
    onDimensionChange?: (dimensions: FloatingWindowDimensions) => void,
    userLoggedIn?: boolean
}) {
    const [visible, setVisible] = useState<boolean>(props.legend !== null);
    const defaultDims = getDefaultDimensions();

    useEffect(() => {
        setVisible(props.legend !== null);
    }, [props.legend]);

    return <>
        {visible && props.legend ? <FloatingWindow
            id='legend-window'
            data-testid='legend-window'
            title={props.legend[0].layer_name || 'Legend'}
            extraActions={<>
                <span
                    id='legend-close'
                    data-testid='legend-close'
                    className='fi-close'
                    onClick={() => setVisible(false)}
                >
                    X
                </span>
            </>}
            visible={visible}
            startX={props.dimensions?.startX ?? defaultDims.startX}
            startY={props.dimensions?.startY ?? defaultDims.startY}
            width={props.dimensions?.width ?? defaultDims.width}
            height={props.dimensions?.height ?? defaultDims.height}
            onDimensionChange={props.onDimensionChange}
        >
            <LegendContent legend={props.legend} />
            <SuperEditorContext>
                <FeatureFeedback
                    feature={FeedbackFeature.LEGEND}
                    enabled={props.userLoggedIn}
                    context={{
                        layer: props.legend[0].layer,
                        layer_name: props.legend[0].layer_name
                    }}
                />
            </SuperEditorContext>
        </FloatingWindow> : null}
    </>
});